import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

const LangContext = createContext({ lang: 'es', prefix: '' });

export function LangProvider({ children }) {
  const location = useLocation();
  const lang = location.pathname.startsWith('/en') ? 'en' : 'es';
  const prefix = lang === 'en' ? '/en' : '';
  return <LangContext.Provider value={{ lang, prefix }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
